import React from 'react';

// import './Ofertas.css';

import Card from '../../components/card/Card';
import Title from '../../components/title/Title';

const Ofertas = props => {
    return (
        <div className="background">
            <Title title="Ofertas" />
            <div className="container">
                <div className="content">
                    <div className="cards">
                        <Card />
                        <Card />
                        <Card />
                        <Card />
                        <Card />
                        <Card />
                        <Card />
                        <Card />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Ofertas;